import { useNavigate } from "react-router-dom";
import type { Workflow } from "../types";
import {
  useActivateWorkflow,
  useDeactivateWorkflow,
  usePublishWorkflow,
  useUpdateWorkflow,
} from "../hooks";

export function WorkflowToolbar({ workflow }: { workflow: Workflow }) {
  const navigate = useNavigate();
  const publish = usePublishWorkflow();
  const activate = useActivateWorkflow();
  const deactivate = useDeactivateWorkflow();
  const update = useUpdateWorkflow();

  async function toggleActive() {
    if (workflow.active) {
      await deactivate.mutateAsync(workflow.id);
    } else {
      await activate.mutateAsync(workflow.id);
    }
  }

  async function toggleDefault() {
    await update.mutateAsync({
      id: workflow.id,
      payload: { defaultWorkflow: !workflow.defaultWorkflow },
    });
  }

  return (
    <div className="flex flex-wrap gap-2">
      <button
        onClick={() => navigate(`/admin/workflows/${workflow.id}/edit`)}
        className="rounded-xl bg-slate-900 px-4 py-2 text-sm font-semibold text-white"
      >
        Edit
      </button>

      <button
        disabled={workflow.published || !workflow.active}
        onClick={() => publish.mutate(workflow.id)}
        className="rounded-xl bg-emerald-600 px-4 py-2 text-sm font-semibold text-white disabled:bg-slate-300"
      >
        {workflow.published ? "Published" : "Publish"}
      </button>

      <button
        onClick={toggleActive}
        className="rounded-xl border px-4 py-2 text-sm font-semibold"
      >
        {workflow.active ? "Deactivate" : "Activate"}
      </button>

      <button
        onClick={toggleDefault}
        className="rounded-xl border px-4 py-2 text-sm font-semibold"
      >
        {workflow.defaultWorkflow ? "Remove Default" : "Set Default"}
      </button>
    </div>
  );
}